/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import {Env} from "./utils";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

const environment = process.env.REACT_APP_ENVIRONMENT
const localEnv = process.env.NODE_ENV === 'development';

const redirectUri = {
    [Env.dev]: "https://brave-plant-0ec6a8203.1.azurestaticapps.net/",
    [Env.qa]: "https://thankful-field-0de7acd03-qa.westeurope.1.azurestaticapps.net",
    [Env.prod]: "https://www.bsp.volvo.com/"
};

const GUID_EA_APP = {
    [Env.dev]: "7923418a-7074-4e7d-8e38-63198056d50c",
    [Env.qa]: "255939a3-d7cd-4424-a73f-33880b71ab1a",
    [Env.prod]: "f47baeb2-95f6-44b4-89d1-4ca251e039da"
    //[Env.prod]: "0125ce00-bcf3-4203-b894-349f76cadf42" EA PROXY
};

const clientId = {
    [Env.dev]: "d9c1f2cd-ff32-4025-b65c-1797a2505251",
    [Env.qa]: "d9c1f2cd-ff32-4025-b65c-1797a2505251",
    [Env.prod]: "d9c1f2cd-ff32-4025-b65c-1797a2505251"
};

export const msalConfig = {
    auth: {
        clientId: environment ? clientId[environment] : clientId[Env.prod],
        authority: "https://login.microsoftonline.com/f25493ae-1c98-41d7-8a33-0be75f5fe603",
        redirectUri: localEnv ? "http://localhost:3000" : environment ? redirectUri[environment] : redirectUri[Env.prod]
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;
                    default:
                        console.log(message);
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [`api://${environment ? GUID_EA_APP[environment] : GUID_EA_APP[Env.prod]}/access_as_user`, "User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
